import moment from 'moment';

export const isToday = (date) => {
    return moment(date, "YYYY-MM-DD", true).isSame(moment(), "day");
}

export const isThisYear = (date) => {
    return moment(date, "YYYY-MM-DD", true).isSame(moment(), "year");
}

export const compareDateIsNextDay = (dateA, dateB) => {
  const fechaBase = moment(dateA, "YYYY-MM-DD", true);
  const fechaComparar = moment(dateB, "YYYY-MM-DD", true);

  if (!fechaBase.isValid() || !fechaComparar.isValid()) {
    return false;
  }

  return fechaBase.clone().add(1, "day").isSame(fechaComparar, "day");
}

export const getDateTextFormat = (date) => {
    if (isThisYear(date)) {
        return moment(date, "YYYY-MM-DD").format("DD/MM");;
    } else {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");;
    }
};
